import { useMemo } from 'react';
import { ClientConfigName, ClientConfigs } from '../../lib/Util';
import { User } from '../../system/User';

export function useLiquidacionAgrupadaConfig(user?: User) {

  const configLiquidacionAgrupada = useMemo<ClientConfigs | undefined>(() => {
    if (!user) return undefined;
    const profileId = user.getProfile().getId();
    if (!profileId) return undefined;
    return user.getClientConfigs().find((c) => c.cltconf_perid === profileId && c.cltconf_nombre === ClientConfigName.OPC_LIQUIDACION_AGRUPADA);
  }, [user]);

  return configLiquidacionAgrupada;
}
